
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","viewBox":"0 0 21 21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.016 0C14.819 0 13 1.787 13 3.984S14.819 8 17.016 8 21 6.181 21 3.984A3.989 3.989 0 0017.016 0zm2.109 4.453h-1.64v1.672a.47.47 0 01-.938 0V4.453h-1.672a.47.47 0 010-.937h1.672V1.875a.47.47 0 01.937 0v1.64h1.641a.47.47 0 010 .938zM12.668 17.278l-2.395-.599-.204-.815a4.31 4.31 0 001.21-2.399.94.94 0 00.677-.786l.156-1.25a.934.934 0 00-.598-.992l.058-1.176.234-.235c.352-.374.643-1.016.033-1.947C11.371 6.363 10.574 6 9.472 6c-.435 0-1.436 0-2.369.626-2.662.056-3.025 1.293-3.025 2.499 0 .28.068.912.113 1.294a.938.938 0 00-.647 1.01l.156 1.25a.94.94 0 00.752.805c.13.86.545 1.702 1.15 2.326l-.218.87-2.395.6a3.505 3.505 0 00-2.66 3.407c0 .173.14.313.312.313h14.375a.314.314 0 00.312-.314 3.508 3.508 0 00-2.66-3.408z"}})])
          )
        }
      }
    